// @ts-nocheck
import { TrackOrderHistoryExportParameters } from "@store/Framework/GoogleAnalytics/trackers/trackHistoryExport";
import ga from "@toolkit/Framework/Common/GoogleAnalytics";

const useExportHistory = (
    parameters: TrackOrderHistoryExportParameters = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => ga.util.getEventTrackerHook(ga.track.historyExport, parameters, options);

export default useExportHistory;
